import { type Common } from './common.js';
import type { VerifyResponse } from './models/address.js';
import type { BasePlaceDetail } from './models/places.js';

export class API {
  common: Common;
  baseEndpoint = '/addresses';

  constructor(common: Common) {
    this.common = common;
  }

  async verify(address: BasePlaceDetail): Promise<VerifyResponse> {
    const url = this.common.constructPath(`/patient-previsit/addresses/verify`);
    return await this.common.postJSON(url, address);
  }
}
